<template>
    <v-dialog persistent v-model="get_dialogSecoundMain.dialog" width="800px" justify-center>
        <v-toolbar dense dark color="blue darken-2">
            <v-toolbar-title>
                <h3>Asignar Encuestas al Periodo </h3>
            </v-toolbar-title>
        <v-spacer></v-spacer>
            <v-btn icon dark @click="HIDDE_DIALOG_SECOUND_MAIN()">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-toolbar>

        <v-card width="auto" tile>
            <v-form ref="form">
                <v-card-text>
                    <v-row dense>
                        <v-col cols="4">
                            <p><label class="font-weight-bold">Periodo: </label> {{model.nombre}}</p>
                        </v-col>
                        <v-col cols="4">
                            <p><label class="font-weight-bold">Fecha Inicio: </label> {{model.fecha_inicial}}</p>
                        </v-col>
                        <v-col cols="4">
                            <p><label class="font-weight-bold">Fecha Final: </label> {{model.fecha_final}}</p>
                        </v-col>
                        <v-col cols="12">
                            <v-select
                            v-model="periodo.encuesta_id"
                                label="Enuesta"
                                :items="get_objectsSecound"
                                :rules="fieldRequired"
                                item-text="nombre"
                                item-value="id"
                                outlined
                                dense>
                            </v-select>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-layout justify-end>
                    <v-btn class="red darken-1 mr-3" dark @click="HIDDE_DIALOG_SECOUND_MAIN()">Cancelar</v-btn>
                    <v-btn class="green darken-1 mr-3" dark @click="save"> Guardar</v-btn>
                    </v-layout>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { Validate } from '@/mixins/validateFormMixin'
export default {
  props: ['model'],
  mixins: [Validate],
  data: () => ({
    periodo: {
      periodo_id: 0
    }
  }),
  components: {},
  mounted () {
    this.getUrlEncuesta('survey.show')
  },
  methods: {
    ...mapActions(['getUrlServices', 'postUrlServicesAction', 'postUrlServicesListActionSecound']),
    save () {
      if (this.$refs.form.validate()) {
        this.periodo.periodo_id = this.model.id
        this.getUrl('survey.periodo')
      } else {
        this.$swal({
          type: 'error',
          icon: 'error',
          title: 'ERROR',
          text: 'Debe seleccionar una encuesta'
        })
      }
    },
    getUrl (objet) {
      const router = this.get_urls[objet]
      this.postUrlServicesAction({ url: router, data: this.periodo })
    },
    getUrlEncuesta (objet) {
      if (this.get_urls != null) {
        const router = this.get_urls[objet]
        this.postUrlServicesListActionSecound({ url: router })
      } else {
        this.getUrlServices()
      }
    },
    ...mapMutations(['HIDDE_DIALOG_SECOUND_MAIN', 'SET_DATA_MAIN', 'CLEAR_DATA_MAIN'])
  },
  computed: {
    ...mapGetters(['get_dialogSecoundMain', 'get_urls', 'get_objectsSecound', 'get_object'])
  },
  watch: {
    get_urls () {
      this.getUrlEncuesta('survey.show')
    },
    get_object (val) {
      if (val.message) {
        this.$swal({
          type: 'error',
          icon: 'error',
          title: 'Error!',
          text: val.message
        })
        return
      }
      this.$swal({
        type: 'success',
        icon: 'success',
        title: 'Exitoso!',
        text: 'La encuesta ha sido vinculada con el periodo'
      })
      this.cancel()
    }
  },
  beforeDestroy () {
    this.CLEAR_DATA_MAIN()
  }
}
</script>

<style>

</style>
